<template>
  <f7-block>
    <f7-row>
      <f7-col width="50">
        <DxNutrition />
      </f7-col>
      <f7-col width="50">
        <f7-block v-if="!loadedGIS">
          <div class="loadingFalse">
            <div class="preloader" />
          </div>
        </f7-block>
        <f7-block v-else>
          <GISWMSMap
            :zoom="zoom"
            :name-map="mainMap"
            :layer="layer"
            :index="'NDVI'"
            :center="center"
            :height="'450px'"
          />
        </f7-block>
      </f7-col>
    </f7-row>
    <f7-row>
      <f7-col width="100">
        <NutritionPlanList />
      </f7-col>
    </f7-row>
  </f7-block>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import NutritionPlanList from '../../wizardNutrition/nutritionPlanList/index.vue';
import DxNutrition from '../../laboratoryNutrition/nutrition/index.vue';
import GISWMSMap from '../../Gis/GISWMSMap/index.vue';
import Api from '../../../services/Api';

export default {
  name: 'Nutrition',
  components: {
    GISWMSMap,
    NutritionPlanList,
    DxNutrition,
  },
  data() {
    return {
      loadedGIS: false,
      zoom: 17,
      mainMap: 'nutrition',
      layer: {
        name: 'nutrition',
        visible: false,
        timeDimension: true,
        baseUrl: Api.getGeoServerTimacagro(),
        options: {
          layers: '',
          format: 'image/png',
          transparent: true,
          styles: '',
        },
      },
      center: {},
    };
  },
  computed: {
    ...mapState('Plantation', ['currentPlantation', 'treeLocations']),
  },
  async beforeMount() {
    try {
      this.layer.options.layers = `client_efemis:${this.currentPlantation.sectorId}`;
      this.center = { ...this.currentPlantation.coordinates };
      await this.fetchLocationsByPlantation();
      this.loadedGIS = true;
    } catch (error) {
      this.$f7.dialog.alert(this.$t(`${error}`));
    }
  },
  methods: {
    ...mapActions('Plantation', ['fetchLocationsByPlantation']),
  },
};
</script>

<style lang="scss" scoped>
@import './Nutrition.styles.scss';
</style>
